var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17L14.763 15.2527C16.1689 13.8592 16.8719 13.1625 16.9801 12.3133C17.0066 12.1053 17.0066 11.8947 16.9801 11.6867C16.8719 10.8375 16.1689 10.1408 14.763 8.74731L13 7",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17L8.76297 15.2527C10.1689 13.8592 10.8719 13.1625 10.9801 12.3133C11.0066 12.1053 11.0066 11.8947 10.9801 11.6867C10.8719 10.8375 10.1689 10.1408 8.76297 8.74731L7 7",
    stroke: "#959595",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationRight2);
export default __webpack_public_path__ + "static/media/pagination-right-2.9c0a607939652c8b807f3824f79a6431.svg";
export { ForwardRef as ReactComponent };